import React from 'react';
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import { DragIndicator } from '@mui/icons-material';
import { IconButton } from '@mui/material';

interface JotDocDragHandleProps {
  listeners?: DraggableSyntheticListeners;
  attributes?: DraggableAttributes;
}

export const JotDocDragHandle: React.FC<JotDocDragHandleProps> = ({ listeners, attributes }) => {
  return (
    <IconButton
      {...listeners}
      {...attributes}
      sx={{
        borderRadius: 0,
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing',
        },
        color: 'textColors.disabled',
        opacity: 0.5,
        '&:hover': {
          color: 'textColors.disabled',
          bgcolor: 'action.hover',
          opacity: 0.8,
        },
      }}
      aria-label="Drag to reorder"
    >
      <DragIndicator />
    </IconButton>
  );
};

